export default __webpack_public_path__ + "static/media/banner_banese.ec92b508.png";